import ApiService from '@/services/core/api.service'

const RawDataService = {
  async get (query) {
    return ApiService.get(`lead-supervisor/raw-data?${query}`)
  },

  async post (payload) {
    return ApiService.post('lead-supervisor/raw-data', payload)
  },

  async put (payload) {
    return ApiService.put(`lead-supervisor/raw-data/${payload.agent}`, payload)
  }
}

export default RawDataService
